import React, { memo } from 'react'
import EventSearchResult from '../../../../../components/Template/Search/Event/EventSearchResult'
import SearchResults from '../../../../../components/Template/Search/SearchResults'

const ResultsList = ({ results, size, maxResults, onResultClick }) => (
  <>
    {results.length > 0 && (
      <SearchResults>
        {results.slice(0, maxResults).map(r => (
          <EventSearchResult
            size={size}
            event={r}
            onClick={onResultClick}
            key={`search-result-event-${r.id}`}
          />
        ))}
      </SearchResults>
    )}
  </>
)

export default memo(ResultsList, (pp, np) => {
  return pp.onResultClick === np.onResultClick && pp.results === np.results
})
